function updateInventoryForColor(color) {
  const $colorBlock = $(`.variant-picker__optioncolor-for-match[data-color="${color}"]`);
  const totalSizes = {};
  $colorBlock.find('.additional-fields-container label').each(function () {
    const size = $(this).attr('data-name');
    totalSizes[size] = parseInt($(this).attr('inventory')) || 0;
  });
  const activeFieldsets = $(`fieldset.variant-picker__option.optionsize.active[datavall="${color}"]`)
    .sort((a, b) => parseInt($(a).attr('data-index')) - parseInt($(b).attr('data-index')));
  const remaining = { ...totalSizes };
  activeFieldsets.each(function () {
    const fieldsetIndex = $(this).attr('data-index');
    const currentSize = $(this).find('label.block-swatch.active').attr('data-name');
    $colorBlock.find('.additional-fields-container label').each(function () {
      const size = $(this).attr('data-name');
      const $swatch = $(
        `fieldset.variant-picker__option.optionsize[data-index="${fieldsetIndex}"] .additional-fields-container label.block-swatch[data-name="${size}"]`
      );
      if (remaining[size] > 0) {
        $swatch.removeClass('out-of-stock');
      } else {
        $swatch.addClass('out-of-stock');
      }
      if (size === currentSize && remaining[size] > 0) {
        remaining[size] -= 1;
      }
      $swatch.attr('inventory', remaining[size] >= 0 ? remaining[size] : 0);
    });
  });

  toggleAddToCartButton();
}


/* ---- Toggle Add to Cart ---- */
function toggleAddToCartButton() {
  const container = $('.stackcoloroptions safe-sticky.product-info');
  const activeSelections = container.find('.product-info__block-list ul.color-selections li.active');
  const elem = document.querySelectorAll(".block-variant_picker ul.color-selections li:not(.stack-option-hidden)");

  if (activeSelections.length < elem.length) {
    container.find('buy-buttons.buy-buttons , form.shopify-product-form')
      .addClass('disableoption')
      .removeClass('activeclick');
    return;
  }

  let anyOutOfStock = false;
  container.find('fieldset.variant-picker__option.optionsize.active').each(function () {
    const activeLabel = $(this).find('label.block-swatch.active');
    if (activeLabel.hasClass('out-of-stock')) {
      anyOutOfStock = true;
    }
  });

  if (anyOutOfStock) {
    container.find('buy-buttons.buy-buttons , form.shopify-product-form')
      .addClass('disableoption')
      .removeClass('activeclick');
  } else {
    container.find('buy-buttons.buy-buttons , form.shopify-product-form')
      .removeClass('disableoption')
      .addClass('activeclick');
  }

  updateA2cText();
}


function updateA2cText(){
  const elem  = document.querySelector("buy-buttons.buy-buttons.buy-buttons--has-dynamic div");
  const count = document.querySelectorAll(".block-variant_picker ul.color-selections li:not(.stack-option-hidden)").length;
  if( elem ){
    elem.setAttribute("data-tooltip", `Select ${count} colors to add to cart`);
    document.querySelector("variant-picker .colors-selected").innerText = `Please select ${count} colors:`
  }

  if( count > 3 ){
    $("button.add-extra_ring").hide();
  }else{
    $("button.add-extra_ring").show();
  }

  document.querySelector(".stackcoloroptions .my-pricee span")?.remove();
  document.querySelector(".stackcoloroptions span.money")?.remove();

  const money = formatCurrency(count * 100);

  document.querySelector(".stackcoloroptions .my-pricee")?.insertAdjacentHTML("beforeend", `<span class="money">$${money}</span>`);
  document.querySelector(".stackcoloroptions .text_cccc")?.insertAdjacentHTML("afterend", `<span class="money">$${money}</span>`);
}


let currentIndex = 0;

function updateCurrentIndex() {
  const elems = document.querySelectorAll(".block-variant_picker ul.color-selections li:not(.stack-option-hidden)");

  let found = false;

  for (let i = 0; i < elems.length; i++) {
    if (!elems[i].classList.contains("active")) {
      currentIndex = i;
      found = true;
      break;
    }
  }

  if (!found) {
    if( currentIndex + 1 >= elems.length ){
      currentIndex = 0;
    }else{
      currentIndex++;
    }
  }
}

document.addEventListener("click", function (e) {
  const target = e.target.closest(".stackcoloroptions .selected-color-boxwrap button.remove-color");
  
  if (target) {
    updateCurrentIndex();
  }
});

// document.addEventListener("click", function (e) {
//   const target = e.target.closest(".stackcoloroptions .selected-color-boxwrap button.remove-color .remove-add_ring");
  
//   if (target) {
//     const tr = target.closest("li");
//     if( tr ){
//       tr.classList.add("stack-option-hidden");
//       const index = tr.getAttribute("data-index");

//       document.querySelector(`.variant-picker__option.optionsize.width_of_size[data-index='${index}']`)?.classList.add("stack-option-hidden");
//     }

//     updateCurrentIndex();
//     toggleAddToCartButton();
//     updateA2cText();
//   }
// });

function rgbStringToHex(rgb) {
  const [r, g, b] = rgb.match(/\d+/g).map(Number);

  return (
    "#" +
    [r, g, b]
      .map(x => x.toString(16).padStart(2, "0"))
      .join("")
  );
}

function formatCurrency(num) {
  return num.toLocaleString('en-IN'); // or 'en-US'
}



document.addEventListener("click", function (e) {
  const target = e.target.closest(".stackcoloroptions .selected-color-boxwrap button.remove-color .remove-add_ring");
  
  if (target) {
    const tr = target.closest("li");
    if( tr ){
      const index = tr.getAttribute("data-index");
      if( index == "3"){
        const elem = document.querySelector(".stackcoloroptions .selected-color-boxwrap li[data-index='4']:not(.stack-option-hidden)");
        if( elem ){
          const eee = document.querySelector(".stackcoloroptions .selected-color-boxwrap li[data-index='4']");

          const background = eee?.querySelector(".color-selected-box")?.style?.background;
          const hex = rgbStringToHex(background);


          const dataName = document.querySelector(".additional-fields-container.datas-4 .block-swatch.active")?.getAttribute("data-name");

          eee.querySelector(".remove-add_ring")?.click();
          eee.querySelector(".remove-ring_color")?.click();

          currentIndex = 2;

          if(!! dataName )
          {
            document.querySelector(`.variant-picker .variant-picker__option-values .swatch-color[data-color='${hex}']`)?.click();
            document.querySelector(`.variant-picker .optionsize .datas-3 .block-swatch[data-name='${dataName}']`)?.click();
          }
          
          updateCurrentIndex();

        }else{
          tr.classList.add("stack-option-hidden");
          document.querySelector(`.variant-picker__option.optionsize.width_of_size[data-index='${index}']`)?.classList.add("stack-option-hidden");
          updateCurrentIndex();
        }
      }else{
        tr.classList.add("stack-option-hidden");
        document.querySelector(`.variant-picker__option.optionsize.width_of_size[data-index='${index}']`)?.classList.add("stack-option-hidden");
        updateCurrentIndex();
      }
    }else{
      updateCurrentIndex();
    }

    toggleAddToCartButton();
    updateA2cText();
  }
});


function updateColorOption(color) {
    const elems = document.querySelectorAll(".block-variant_picker ul.color-selections li:not(.stack-option-hidden)");
    elem = elems[currentIndex];
    if( ! elem ){
      elem = elems[0];
    }
    elem.querySelector(".color-selected-box").style.background = color;

    elem.classList.add("active");
}

function updateSizeOption(color_code, color_name) {
    const elems = document.querySelectorAll(".variant-picker  fieldset.optionsize");
    elem = elems[currentIndex];
    if( ! elem ){
      elem = elems[0];
    }
    elem.classList.add("active");
    elem.setAttribute("datavall", color_name);
    elem.querySelector("span.color-selecte").style.background = color_code;
    if( ! elem.querySelector(".additional-fields-container label.active") ){
      elem.querySelector(".additional-fields-container label").click();
    }

    const labels = elem.querySelectorAll(".additional-fields-container label");
    labels.forEach(label => {
        label.setAttribute("selected-color", color_name);
    });
}

document.addEventListener("click", function (event) {
  const swatch = event.target.closest(".block-variant_picker .variant-picker__option-values .swatch-color");
  if (swatch) {
    const color_code = swatch?.dataset.color;
    const color_name = swatch?.dataset.value;
    updateColorOption(color_code);
    updateSizeOption(color_code, color_name);
    updateCurrentIndex();
    updateInventoryForColor(color_name);
  }
});

//this is for handle extra ring button click
document.addEventListener("click", function (event) {
  const button = event.target.closest("button.add-extra_ring");

  if (button) {
    document.querySelector("ul.color-selections li.stack-option-hidden")?.classList.remove("stack-option-hidden");
    document.querySelector("fieldset.optionsize.stack-option-hidden")?.classList.remove("stack-option-hidden");
    updateCurrentIndex();
    toggleAddToCartButton();
    updateA2cText();
  }
});